/* src/app/modules_v2/booking/locations/components/sections/location-availability-section/timeoff-dialog.component.css */
.timeoff-dialog {
  width: 100%;
  max-width: 600px;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  margin: -24px -24px 0 -24px;
}
.dialog-header h2 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.dialog-header h2 mat-icon {
  color: #666;
}
.close-button {
  margin-right: -12px;
}
mat-dialog-content,
.mat-mdc-dialog-content {
  padding: 24px !important;
  max-height: 70vh;
  overflow-y: auto;
}
.timeoff-form {
  width: 100%;
}
.info-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background: #f9ffe0;
  border-left: 3px solid var(--cf-brand-dark);
  border-radius: 4px;
}
.info-box mat-icon {
  color: var(--cf-brand-dark);
}
.info-box span {
  font-weight: 500;
  color: var(--cf-brand-dark);
}
.duration-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background: #f5f5f5;
  border-left: 3px solid #9e9e9e;
  border-radius: 4px;
  margin-top: 10px;
}
.duration-info mat-icon {
  color: #666;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.duration-info span {
  font-size: 13px;
  color: #555;
}
.w-100 {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px 15px -10px;
}
.col-md-6,
.col-md-12 {
  padding: 0 10px;
}
.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.mb-3 {
  margin-bottom: 20px;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 24px !important;
  margin: 0 -24px -24px -24px;
  border-top: 1px solid #e0e0e0;
  gap: 10px;
}
@media (max-width: 768px) {
  .timeoff-dialog {
    max-width: 100%;
  }
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .dialog-header {
    padding: 16px 20px;
  }
  mat-dialog-content,
  .mat-mdc-dialog-content {
    padding: 20px !important;
  }
  mat-dialog-actions,
  .mat-mdc-dialog-actions {
    flex-direction: column-reverse;
  }
  mat-dialog-actions app-button,
  .mat-mdc-dialog-actions app-button {
    width: 100%;
  }
}
/*# sourceMappingURL=timeoff-dialog.component.css.map */
